<template>
	<div id="app">
		<router-view></router-view>
		<!-- Componente chamado na rota é renderizado aqui dentro -->
	</div>
</template>

<script>
export default {
	name: 'App',
	data () {
		return {
			section: 'Head'
		}
	},
	methods: {

	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?664e1be9